import { useOutletContext } from 'react-router-dom';
import { useMemo } from 'react';
import { useRexScreen } from '../context/RexContext';

/**
 * Stand-in for pillar screens that arrive in later build phases. Keeps the
 * Layer 2 navigation fully traversable and shows which phase delivers the screen.
 */
export default function PillarPlaceholder({ title, phase, description }) {
  const { programme } = useOutletContext();
  const snapshot = useMemo(() => ({ title, phase, description, programme: programme?.name }), [title, phase, description, programme?.name]);
  useRexScreen({ snapshot });

  return (
    <div className="content">
      <div className="placeholder-page">
        <span className="placeholder-badge">{phase}</span>
        <h3>{title}</h3>
        <p>{description}</p>
        <p style={{ color: '#b4b2a9' }}>Programme: {programme?.name}</p>
      </div>
    </div>
  );
}
